import { useLang } from "@/i18n";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="relative border-y gold-hairline bg-ink/60 py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-lg sm:text-xl tracking-[0.2em] text-slate-400 px-8">{item}</span>
            <span className="text-gold text-xs">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
